export class ApiException extends Error {

    messageCode?: string;
    status: number;
    messageTags: any;
    requestId?: string;

    constructor(message: string, messageCode: string, status: number, messageTags?: any, requestId?: string) {
        super(message);
        Object.setPrototypeOf(this, ApiException.prototype);
        this.name = "ApiException";
        this.messageCode = messageCode;
        this.status = status;
        this.messageTags = messageTags;
        this.requestId = requestId;
    }
}

export const isApiException = (ex: any): ex is ApiException => {
    return !!ex && ex instanceof ApiException;
}